import { queryOptions } from "@tanstack/react-query";
import {
  createOrganizationLabel,
  getOrganizationLabelDeletionImpact,
  listOrganizationLabels,
  removeOrganizationLabel,
  updateOrganizationLabel,
} from "api-client";

import { type Label, type LabelsRepository } from "./LabelsRepository";

export function createOrganizationLabelsRepository(
  organizationId: string,
): LabelsRepository {
  const listOptions = queryOptions<Label[]>({
    queryKey: ["labels", "organization", organizationId, "list"],
    async queryFn() {
      const response = await listOrganizationLabels({
        path: { organizationId },
      });
      return response.data.data;
    },
  });

  return {
    listOptions,
    async createLabel(input) {
      const response = await createOrganizationLabel({
        path: { organizationId },
        body: input,
      });
      return response.data.data;
    },
    async getDeletionImpact(labelId) {
      const response = await getOrganizationLabelDeletionImpact({
        path: { organizationId, labelId },
      });
      return response.data.data;
    },
    async removeLabel(labelId: string) {
      return removeOrganizationLabel({
        path: { organizationId, labelId },
      });
    },
    async updateLabel(labelId, input) {
      return updateOrganizationLabel({
        path: { organizationId, labelId },
        body: input,
      });
    },
  };
}
